
import React from 'react'
import { Col, Row } from 'reactstrap';
import ValidationField from '../../../Components/ValidationField/ValidationField';
import { FaCheck, FaTimes, FaClock, FaBan } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';


function Form() {


  const [t] = useTranslation()
  // 'pending_approve', 'approved', 'rejected', 'pending_cancellation', 'cancelled'
  const stateSelect = [
    { label: <div className='orderStatus_select'><FaClock /> {t("Pending Approve")}</div>, value: "pending_approve" },
    { label: <div className='orderStatus_select'><FaCheck /> {t("Approved")}</div>, value: "approved" },
    { label: <div className='orderStatus_select'><FaTimes /> {t("Rejected")}</div>, value: "rejected" },
    { label: <div className='orderStatus_select'><FaBan /> {t("Pending Cancellation")}</div>, value: "pending_cancellation" }
  ];


  return (
    <Row xs={1} sm={1} md={1} lg={2} xl={2}>
      <Col>

        <ValidationField name="state" type='Select' option={stateSelect} />
        <ValidationField name="delivery_link" />



      </Col>
      <Col>
        <ValidationField name="admin_note" />
        <ValidationField name="deliviration_estimated_time" Format="YYYY/MM/DD" type='Date' />

      </Col>



    </Row>
  )
}

export default Form


